module.exports = __webpack_public_path__ + "static/media/job_property_area.e20dcbf0.svg";